// import Vue from 'vue'
import Vue from 'vue'
import {
  GET_JOB,
  ADD_JOB,
  UPDATE_JOB,
  DELETE_JOB,
  REQUEST_JOB,
  GET_CONTRACT_TYPES_OF_CONTACT,
  ERROR_XHR
} from '../mutation-types'

/**
 *
 * @param dispatch
 * @returns {Promise}
 */
export const getJobs = ({ dispatch }, contactId) => {
  dispatch(REQUEST_JOB)
  return new Promise((resolve, reject) => {
    Vue.http
      .get('job/contact/' + contactId)
      .then(
        (response) => {
          dispatch(GET_JOB, response.json())
          resolve()
        },
        (response) => {
          dispatch(ERROR_XHR, response.json())
          reject()
        })
  })
}

export const getContractTypeByContact = ({ dispatch }, contactId) => {
  dispatch(GET_CONTRACT_TYPES_OF_CONTACT)
  console.log('getContractTypeByContact ' + contactId)
  return new Promise((resolve, reject) => {
    Vue.http.get('contract_type/' + contactId)
      .then(
        (response) => {
          console.log('getContractTypeByContact Reponse ' + response.json())
          dispatch(GET_CONTRACT_TYPES_OF_CONTACT, response.json())
          resolve()
          // return response.json()
        },
        (response) => {
          dispatch(ERROR_XHR, response.json())
          console.log('getContractTypeByContact Reject ' + response.json())
          reject()
        })
  })
}

/**
 * Add a new job
 * @param dispatch
 * @param job
 */
export const addJob = ({ dispatch }, job) => {
  dispatch(REQUEST_JOB)
  Vue.http
    .post('job', job)
    .then(
      (response) => {
        let data = response.json()
        dispatch(ADD_JOB, data)
      },
      (response) => {
        dispatch(ERROR_XHR, response.json())
      }
    )
}

/**
 * Edit a job
 *
 * @param dispatch
 * @param oldContact The former job data
 * @param newContact The new job data
 */
export const editJob = ({ dispatch }, oldJob, newJob) => {
  dispatch(REQUEST_JOB)
  Vue.http
    .put('job/' + newJob.id, newJob)
    .then(
      (response) => {
        dispatch(UPDATE_JOB, oldJob, newJob)
      },
      (response) => {
        dispatch(ERROR_XHR, response.json())
      }
    )
}

/**
 * Delete a job
 *
 * @param dispatch
 * @param job
 */
export const deleteJob = ({ dispatch }, job) => {
  dispatch(REQUEST_JOB)
  Vue.http.delete('job/' + job.id)
    .then(
      (response) => {
        dispatch(DELETE_JOB, job)
      },
      (response) => {
        dispatch(ERROR_XHR, response.json())
      }
    )
}



// WEBPACK FOOTER //
// ./src/vuex/actions/jobActions.js